import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';

const MyNavbar = () => {
    return (
        <>
            <div className="navbar-container reveal4">
                <Navbar>
                    <Container fluid className="flex-column flex-md-row"> {/* Flexbox dla responsywności */}
                        <Link to="/" className="navbar-brand mb-3 mb-md-0" > {/* Dodajemy margines na małych ekranach */}
                            <img src="/img/Logo.svg" className="img-fluid" alt="Logo" />
                        </Link>
                        <Nav className="ml-auto">
                            <NavLink to="/" className="nav-link">
                                <div className="nav-icon"><FontAwesomeIcon icon={faHouse} /></div>
                            </NavLink>
                            <NavLink to="/about" className="nav-link">O NAS</NavLink>
                            <NavLink to="/services" className="nav-link">USŁUGI</NavLink>
                            <NavLink to="/contact" className="nav-link">KONTAKT</NavLink>
                        </Nav>
                    </Container>
                </Navbar>
            </div>
        </>
    );
};

export default MyNavbar;